// extracted by mini-css-extract-plugin
export default {"editButton":"EditProfileButton_editButton__5Ar6x"};